import React, { useEffect } from "react";

import { useRecoilState, useRecoilValueLoadable } from "recoil";
import { apiState, asyncGetAPI, deleteAPI, updateAPI } from "lib/store/user";

import { Button } from "@atsent/components";

import "./API.scss";

export const API: React.FC = () => {
  const asyncApi = useRecoilValueLoadable(asyncGetAPI);
  const [api, setAPI] = useRecoilState(apiState);

  useEffect(() => {
    if (asyncApi.state !== "hasValue") return;
    setAPI(asyncApi.contents);
  }, [asyncApi.state, asyncApi.contents, setAPI]);

  return (
    <div className={`API contents`}>
      <span className={"title"}>Your API Key</span>
      <div className={"inline-box"}>
        {!!api.key ? (
          <>
            <span>{api.key}</span>
            <Button
              click={async () => {
                await deleteAPI();
                const { key } = await updateAPI();
                setAPI(({ created }) => ({ created, key }));
              }}
              outline
            >
              Revoke and re-generate
            </Button>
          </>
        ) : (
          <Button
            click={async () => {
              const { key } = await updateAPI();
              setAPI(({ created }) => ({ created, key }));
            }}
          >
            발급 받기
          </Button>
        )}
      </div>
    </div>
  );
};
